import * as React from 'react';

import { FeedContainer } from './FeedContainer';
import { FiltersContainer } from './FiltersContainer';
import { OfferFromHistoryContainer } from './OfferFromHistoryContainer';
import { ShowMoreContainer } from './ShowMoreContainer';
import { useOffersHistoryContext } from '../../context';
import { FullscreenView } from '../../components/Desktop';
import { MoreDetailed } from '../../components/shared/MoreDetailed';

interface IFullscreenViewContainerProps {
  isFullscreenViewOpened: boolean;
  openFullscreenView: VoidFunction;
  closeFullscreenView: VoidFunction;
  onClose(): void;
}

export const FullscreenViewContainer: React.VFC<IFullscreenViewContainerProps> = props => {
  const { isFullscreenViewOpened, openFullscreenView, closeFullscreenView, onClose } = props;
  const {
    activeOfferId,
    data: {
      listing: { data: offersHistoryData, isFetching },
    },
    resetAllFilters,
    getOffersHistory,
    setViewedOffer,
    openOfferFromHistory,
  } = useOffersHistoryContext();

  const handleOfferClick = React.useCallback(
    (offerId: number) => {
      openFullscreenView();
      openOfferFromHistory({ cianId: offerId });
    },
    [openFullscreenView, openOfferFromHistory],
  );

  const onFullscreenClose = React.useCallback(() => {
    closeFullscreenView();
    /** При закрытии фулскрина, фильтры, которые накликал юзер и данные листинга сбросятся */
    resetAllFilters();
    onClose();
  }, [closeFullscreenView, onClose, resetAllFilters]);

  /**
   * Если в открытом фулскрине нет данных листинга и они не в процессе загрузки,
   * то загрузить их и открыть оффер в сайдбаре
   * */
  React.useEffect(() => {
    if (isFullscreenViewOpened && !offersHistoryData && !isFetching) {
      getOffersHistory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFullscreenViewOpened]);

  /** Отмечает оффер как просмотренный */
  React.useEffect(() => {
    if (isFullscreenViewOpened && activeOfferId) {
      setViewedOffer(activeOfferId);
    }
  }, [isFullscreenViewOpened, activeOfferId, setViewedOffer]);

  return (
    <FullscreenView
      title="История объявлений в этом доме"
      isOpened={isFullscreenViewOpened}
      onClose={onFullscreenClose}
      offersTable={
        <FeedContainer
          onOfferClick={handleOfferClick}
          showMoreBtn={<ShowMoreContainer />}
          activeOfferId={activeOfferId}
          scrollable
          selectable
        />
      }
      filters={<FiltersContainer />}
      offerFromHistory={<OfferFromHistoryContainer key={activeOfferId} />}
      moreDetailed={<MoreDetailed />}
    />
  );
};
